import { Route, Switch } from 'react-router-dom';
import { AnonymousResultsPage } from './ResultsPage';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export let GatePath = /*#__PURE__*/function (GatePath) {
  GatePath["ANONYMOUS_GATE"] = "/";
  return GatePath;
}({});
export const AnonymousGatePages = _ref => {
  let {
    handlers,
    externalViewer,
    deviceType,
    showCartHeader
  } = _ref;
  return /*#__PURE__*/React.createElement(DomainSearchGateModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: GatePath.ANONYMOUS_GATE,
    render: () => /*#__PURE__*/React.createElement(AnonymousResultsPage, {
      handlers: handlers,
      externalViewer: externalViewer,
      deviceType: deviceType,
      showCartHeader: showCartHeader
    })
  })));
};
//# sourceMappingURL=AnonymousGatePages.js.map